import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Container, FormGroup, InputGroup, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import "@vtaits/react-color-picker/dist/index.css";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { json, Link, useParams } from "react-router-dom";
import * as url from "../../helpers/url_helper"
import { data } from "pages/AllCharts/chartjs/linechart";
import 'react-international-phone/style.css';
import { PhoneInput } from 'react-international-phone';
import moment from "moment";
const animatedComponents = makeAnimated();

const UpdateAttestation = () => {
  const { id } = useParams();
  //FOR ATTESTATION FORM
  const [selectedBeneficiary, setselectedBeneficiary] = useState(null);
  const [attestation, setAttestation] = useState(null);
  const [loading, setLoading]= useState(false)
  const [loadingBord, setLoadingBord]= useState(false)
  const [birthDate, setbirthDate]= useState(null)
  const [age, setAge]= useState(null)
  const [error, setError]= useState(null)
  const [success, setSuccess]= useState(null)
  const [errorClient, setErrorClient]= useState(null)
  const [successClient, setSuccessClient]= useState(null)
  const [beneficiaries, setBeneficiaries]= useState([]);
  const [beneficiary, setBeneficiary]= useState([]);
  const [allZones, setAllZones]= useState([])
  const [zones, setZones]= useState([])
  const [selectedZone, setselectedZone] = useState(null);
  const [countries, setCountries]= useState([])
  const [tranches, setTranches]= useState([])
  const [tranche, setTranche]= useState(null)
  const [tarifications, setTarifications]= useState([])
  const [tarification, setTarification]= useState([])
  const [periodicities, setPeriodicities]= useState([])
  const [periodicity, setPeriodicity]= useState(null)
  const [delay, setDelay]= useState(0)
  const [amount, setAmount]= useState(0)
  const [selectedCountry, setselectedCountry] = useState(null);
  const [from, setFrom]= useState(moment().format("YYYY-MM-DD"))
  const [to, setTo]= useState(moment().format("YYYY-MM-DD"))
  const [modal_beneficiary, setmodal_beneficiary] = useState(false);

  //FOR CLIENT FORM
  const [clientLastName, setClientLastName]= useState("")
  const [clientFirstName, setClientFirstName]= useState("")
  const [clientBirthDate, setClientBirthDate]= useState(null)
  const [clientPassport, setClientPassport]= useState(null)
  const [clientPassportExpire, setClientPassportExpire]= useState(null)
  const [genders, setGenders]= useState([{label: "MASCULIN", value: "MALE"}, {label: "FEMININ", value: "FEMALE"}])
  const [clientGender, setClientGender]= useState(null)
  const [clientPhone, setClientPhone]= useState("")
  const [clientEmail, setClientEmail]= useState(null)
  const [clientCountries, setClientCountries]= useState([])
  const [clientNationality, setClientNationality]= useState(null)
  const [clientResidence, setClientResidence]= useState(null)

  const checkInput = () => {
    if (beneficiary.length==0) { setError('Veuillez sélectionner le bénéficiare svp'); return false;}
    if (!selectedZone) { setError('Veuillez sélectionner la zone de votre voyage svp'); return false;}
    if (!from || !from.trim()) { setError('Veuillez entrer la date de début de prise en charge svp'); return false;}
    if (!to || !to.trim()) { setError('Veuillez entrer la date de fin de prise en charge svp'); return false;}
    if (!selectedCountry) { setError('Veuillez sélectionner votre pays de destination svp'); return false;}
    if (delay<=0) { setError('Le nombre de jour ne peut être inférieur ou égal à zéro'); return false;}
      setError("")
      return true;
  };

  const checkClientInput = () => {
    if (!clientLastName || !clientLastName.trim()) { setErrorClient('Veuillez entrer le nom du client svp'); return false;}
    if (!clientFirstName || !clientFirstName.trim()) { setErrorClient('Veuillez entrer le prénom du client svp'); return false;}
    if (!clientBirthDate || !clientBirthDate.trim()) { setErrorClient('Veuillez entrer la date de naissance du client svp'); return false;}
    if (!clientPassport || !clientPassport.trim()) { setErrorClient('Veuillez entrer le numéro de passport du client svp'); return false;}
    if (!clientPassportExpire || !clientPassportExpire.trim()) { setErrorClient('Veuillez entrer la date d\'expiration du passport du client svp'); return false;}
    if (!clientGender) { setErrorClient('Veuillez sélectionner le genre du client svp'); return false;}
    if (!clientPhone || !clientPhone.trim()) { setErrorClient('Veuillez entrer le téléphone du client svp'); return false;}
    if (!clientEmail || !clientEmail.trim()) { setErrorClient('Veuillez entrer le mail du client svp'); return false;}
    if (!clientNationality) { setErrorClient('Veuillez sélectionner la nationalité du client svp'); return false;}
    if (!clientResidence) { setErrorClient('Veuillez sélectionner le pays de résidence du client svp'); return false;}
      setErrorClient("")     
      return true;
  };
  
  const removeBodyCss = () => { document.body.classList.add("no_padding"); };

  const tog_beneficiary = () => { setmodal_beneficiary(!modal_beneficiary); removeBodyCss(); };
  const handleZone=(event)=> { 
    setselectedZone(event); 
    const getZone = allZones.find(zone => zone.id === event.value);
    const pays = getZone ? getZone.countries : [];
    calculateAmountWithZone(event)
    
    let countryArray= [{label: "Tout pays", value: ''}];
    countryArray=[...countryArray, ...pays.map(item=>({ label: item.name, value: item.id }))]
    setCountries(countryArray); 
  }

  const handleSelectCountry=(event)=> { setselectedCountry(event); console.log(event) }
  const handleDelayStart=(dateStr)=> { 
    let delay= moment(to).diff(moment(dateStr), "days"); setDelay(delay)
    let period = periodicities.find(period => period.min <= delay && period.max>= delay);
    setPeriodicity(period ? period: null)
    calculateAmountWithDelay(period)
    }

  const handleDelayEnd=(dateStr)=> { 
    let delay= moment(dateStr).diff(moment(from), "days"); setDelay(delay)
    let period = periodicities.find(period => period.min <= delay && period.max>= delay);
    setPeriodicity(period ? period: null)
    calculateAmountWithDelay(period)
   }

  function handleBeneficiary(selectedBeneficiary) {
    setbirthDate(moment(selectedBeneficiary.data.birth_date).format("DD/MM/YYYY"));
    setselectedBeneficiary(selectedBeneficiary);
    let age=moment().diff(moment(selectedBeneficiary.data.birth_date), "years")
    setAge(age);
    // Remplacer le bénéficiaire au lieu de l'ajouter
    setBeneficiary([selectedBeneficiary.data]);
    let tranche = tranches.find(trch => trch.min<= age && trch.max>=age);
    setTranche(tranche ? tranche: null)
    calculateAmountWithTranche(tranche)
  }
  const calculateAmountWithTranche=(trancheSelected)=>{
    if(selectedZone && periodicity){
      let tarification = tarifications.find(tarif => tarif.tranche.id=== trancheSelected.id && tarif.zone.id===selectedZone.value && tarif.periodicity.id===periodicity.id);
      console.log(tarification);
      setTarification(tarification)
      setAmount(tarification.tarif)
    }
  }
  const calculateAmountWithZone=(zone)=>{
    if(tranche && periodicity){
      let tarification = tarifications.find(tarif => tarif.tranche.id=== tranche.id && tarif.zone.id===zone.value && tarif.periodicity.id===periodicity.id);
      console.log(tarification);
      setTarification(tarification)
      setAmount(tarification.tarif)
    }
   }
  const calculateAmountWithDelay=(delay)=>{ 
    if(selectedZone && tranche){
      let tarification = tarifications.find(tarif => tarif.tranche.id=== tranche.id && tarif.zone.id===selectedZone.value && tarif.periodicity.id===delay.id);
      console.log(tarification);
      setTarification(tarification)
      setAmount(tarification.tarif)
    }
   }

  document.title = "Attestation | Modifier une attestation";

  const loadBeneficiaries= (search)=>{
    setLoading(true)
    let beneficiariesArray= [{label: "Selectionez le bénéficiaire", value: "", data: null}]
    fetch(url.BACKEND_URL+"/beneficiaries?&page=0&size=100"+(search!=null ? "&search="+search: ""), {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      console.log(responseJson);
      if (responseJson.status==200) { 
        beneficiariesArray=[
          ...beneficiariesArray,
          ...responseJson.data.map(item=>({
            label: item.last_name+" "+item.first_name+" "+item.passport_number,
            value: item.id,
            data: item
          }))];
        setBeneficiaries(beneficiariesArray)
        setLoading(false)
    } else { setBeneficiaries([]); setLoading(false) }
    }) .catch((error) => { setLoading(false) });
  }
  
  const getByReference= ()=>{
    setLoading(true)
    fetch(`${url.BACKEND_URL}/attestations/${id}`, { method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => {
      console.log(`GET BY REFERENCE ${id}`, responseJson);
      if (responseJson.status==200) {
        const data = responseJson.data;
        setAttestation(data);

        // Pré-remplir les champs du formulaire
        if (data.beneficiaries && data.beneficiaries.length > 0) {
          const beneficiaryData = data.beneficiaries[0];
          const beneficiaryOption = {
            label: `${beneficiaryData.last_name} ${beneficiaryData.first_name} ${beneficiaryData.passport_number}`,
            value: beneficiaryData.id,
            data: beneficiaryData
          };
          setselectedBeneficiary(beneficiaryOption);
          setBeneficiary([beneficiaryData]);
          setbirthDate(moment(beneficiaryData.birth_date).format("DD/MM/YYYY"));
          const beneficiaryAge = moment().diff(moment(beneficiaryData.birth_date), "years");
          setAge(beneficiaryAge);

          // Trouver la tranche d'âge
          let tranche = tranches.find(trch => trch.min <= beneficiaryAge && trch.max >= beneficiaryAge);
          setTranche(tranche ? tranche : null);
        }

        // Pré-remplir la zone et charger les pays de cette zone
        if (data.zone) {
          setselectedZone({ label: data.zone.name, value: data.zone.id });

          // Charger les pays de la zone
          const getZone = allZones.find(zone => zone.id === data.zone.id);
          if (getZone) {
            const pays = getZone.countries || [];
            let countryArray = [{ label: "Tout pays", value: '' }];
            countryArray = [...countryArray, ...pays.map(item => ({ label: item.name, value: item.id }))];
            setCountries(countryArray);
          }
        }

        // Pré-remplir le pays de destination
        if (data.destination) {
          setselectedCountry({ label: data.destination.name, value: data.destination.id });
        }

        // Pré-remplir les dates
        if (data.startfrom) {
          setFrom(moment(data.startfrom).format("YYYY-MM-DD"));
        }
        if (data.to) {
          setTo(moment(data.to).format("YYYY-MM-DD"));
        }

        // Calculer le délai
        if (data.startfrom && data.to) {
          const calculatedDelay = moment(data.to).diff(moment(data.startfrom), "days");
          setDelay(calculatedDelay);

          // Trouver la périodicité
          let period = periodicities.find(p => p.min <= calculatedDelay && p.max >= calculatedDelay);
          setPeriodicity(period ? period : null);
        }

        // Pré-remplir le montant
        if (data.tarification) {
          setTarification(data.tarification);
          setAmount(data.tarification.tarif);
        }

        setLoading(false);
      }
      else { setLoading(false) }
    }) .catch((error) => { setLoading(false) });
  }
 
  const loadZones=()=> {
      setLoadingBord(true)
      let zonesArray= [{label: "Toutes zones", value: ''}];
      fetch(url.BACKEND_URL+"/zones", {
        method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => { 
        setAllZones(responseJson.data)
        if (responseJson.status==200) {
           zonesArray=[
            ...zonesArray,
            ...responseJson.data.map(item=>({
            label: item.name,
            value: item.id
          }))];
          setZones(zonesArray)
          setLoadingBord(false)
      } else { setZones([]); setLoadingBord(false) }
      }) .catch((error) => { setLoadingBord(false) });
    };
  
    const loadTarifications=()=> {
      setLoadingBord(true)
      fetch(url.BACKEND_URL+"/tarifications", {
        method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => { 
        console.log("Tarification", responseJson.data);
        if (responseJson.status==200) {
          setTarifications(responseJson.data)
          setLoadingBord(false)
      } else { setTarifications([]); setLoadingBord(false) }
      }) .catch((error) => { setLoadingBord(false) });
    };
    
    const loadTranches=()=> {
      setLoadingBord(true)
      fetch(url.BACKEND_URL+"/tranches", {
        method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => { 
        console.log("Tranche", responseJson.data);
        
        if (responseJson.status==200) {
          setTranches(responseJson.data)
          setLoadingBord(false)
      } else { setTranches([]); setLoadingBord(false) }
      }) .catch((error) => { setLoadingBord(false) });
    };
    
    const loadCountries=()=> {
      fetch(url.BACKEND_URL+"/countries", {
        method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => {         
        if (responseJson.status==200) { 
          setClientCountries(responseJson.data.map(item=>({
            label: item.name,
            value: item.id
          }))); 
        } 
        else { setCountries([]); setLoadingBord(false) }
      }) .catch((error) => { setLoadingBord(false) });
    };
    
    const loadPeriodicities=()=> {
      setLoadingBord(true)
      fetch(url.BACKEND_URL+"/periodicities", {
        method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => { 
        console.log("Periodicities", responseJson.data);
        if (responseJson.status==200) {
          setPeriodicities(responseJson.data)
          setLoadingBord(false)
      } else { setPeriodicities([]); setLoadingBord(false) }
      }) .catch((error) => { setLoadingBord(false) });
    };

    const updateAttestation= ()=>{
      const inputError = checkInput();
      if (inputError) {
        setLoadingBord(true);
        const jsonData= {
          user: {id: JSON.parse(localStorage.getItem("authUser")).id},
          plan: {id: 1},
          zone: {id: selectedZone.value},
          tarification: {id: tarification.id},
          startfrom: from,
          to: to,
          period: delay,
          destination: {id: selectedCountry.value},
          beneficiaries: beneficiary
        };
        console.log("Données à mettre à jour:", jsonData);

         fetch(`${url.BACKEND_URL}/attestations/${id}`, {
          method: 'PUT',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify(jsonData)  })
        .then((response) => response.json())
        .then((responseJson) => {
          console.log(responseJson);
          if (responseJson.status==200) {
            setSuccess("Attestation modifiée avec succès!");
            setLoadingBord(false);
            setTimeout(() => {
              window.location.href = "/attestations";
            }, 1500);
        } else {
          setError(responseJson.message);
          setLoadingBord(false);
        }
        }) .catch((error) => {
          setError(error.message || "Erreur lors de la modification");
          setLoadingBord(false);
        });
      }
    } 

    const saveUser= (beneficiary)=>{
      const now = new Date().toISOString();
      const jsonData= JSON.stringify({ company: {id: JSON.parse(localStorage.getItem("authUser")).company.id}, last_name: clientLastName, first_name: clientFirstName, email: clientEmail, phone: clientPhone, password: "012345", beneficiaries: [{id: beneficiary}], roles: [{id: 1}], created_date: now, updated_date: now });
      
      fetch(url.BACKEND_URL+"/users", { method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: jsonData })
      .then((response) => response.json())
      .then((responseJson) => {
        console.log("User", responseJson.data);
        if (responseJson.status==200) { 
          setSuccessClient(responseJson.message)
          tog_beneficiary()
        } 
        else { setErrorClient(responseJson.message); }
      }) .catch((error) => { /*setLoader(false);*/ console.log(error); }); 
  }
  
  const processSaveBeneficiary= ()=>{
    const inputError = checkClientInput();
    if (inputError) {
      const now = new Date().toISOString();
      const jsonData= JSON.stringify({ last_name: clientLastName, first_name: clientFirstName, gender: clientGender.value, birth_date: clientBirthDate, phone: clientPhone, email: clientEmail, passport_number: clientPassport, passport_expire: clientPassportExpire, nationality: {id: clientNationality.value}, residence: {id: clientResidence.value}, created_date: now, updated_date: now });
      console.log(jsonData);
      // setLoader(true)
      fetch(url.BACKEND_URL+"/beneficiaries", { method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: jsonData })
      .then((response) => response.json())
      .then((responseJson) => {
        console.log("Beneficiary", responseJson.data);
        if (responseJson.status==200) { 
          setBeneficiaries(...beneficiaries, {label: clientLastName+" "+clientFirstName, value: responseJson.data.id, data: responseJson.data});
          saveUser(responseJson.data.id); 
        }
        else { /* setLoader(false);*/ setErrorClient(responseJson.message) }
      }) .catch((error) => { /* setLoader(false); */ console.log(error); }); 
    }
  }
  
  useEffect(()=>{
    loadBeneficiaries(null);
    loadZones();
    loadTranches();
    loadTarifications();
    loadPeriodicities();
    loadCountries();
  }, [])

  // Charger l'attestation après que les données de référence soient chargées
  useEffect(()=>{
    if (allZones.length > 0 && tranches.length > 0 && periodicities.length > 0) {
      getByReference();
    }
  }, [allZones, tranches, periodicities])
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs maintitle="AMAVIE" title="Attestation" breadcrumbItem="Modifier attestation" />
          <Modal isOpen={modal_beneficiary} toggle={tog_beneficiary} size="lg">
            <ModalHeader className="mt-0" toggle={tog_beneficiary}>Formulaire de création d'un client</ModalHeader>
            <ModalBody>
              <form>
                <Row>
                  <Col lg="3">
                    <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                      <Label>Genre</Label>
                      <Select
                        value={clientGender} 
                        isMulti={false}
                        onChange={(selected) => { setClientGender(selected); }}
                        options={genders} 
                        classNamePrefix="select2-selection" 
                        isLoading={false}
                      />
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="mb-3">
                      <Label>Nom</Label>
                      <input className="form-control" onChange={(event)=>{ setClientLastName(event.target.value); }}placeholder="Nom du client" type="text" id="example-datetime-local-input"/>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="mb-3">
                      <Label>Prénoms</Label>
                      <input className="form-control" onChange={(event)=>{ setClientFirstName(event.target.value); }} placeholder="Prénoms du client" type="text" id="example-datetime-local-input"/>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <FormGroup className="form-group mb-3">
                      <Label>Date de naissance</Label>
                      <InputGroup className="">
                        <Flatpickr
                          className="form-control d-block"
                          placeholder="Date de naissance"
                          value={from}
                          options={{ altInput: true, altFormat: "Y-m-d", dateFormat: "Y-m-d" }}
                          onChange={(date, dateStr) => {setClientBirthDate(dateStr);}}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label>Numéro passport</Label>
                      <input className="form-control" placeholder="Numéro passport" onChange={(event)=>{ setClientPassport(event.target.value); }} type="text" id="example-datetime-local-input"/>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <FormGroup className="form-group mb-3">
                      <Label>Date d'expiration</Label>
                      <InputGroup className="">
                        <Flatpickr
                          className="form-control d-block"
                          placeholder="Date d'expiration"
                          value={from}
                          options={{ altInput: true, altFormat: "Y-m-d", dateFormat: "Y-m-d" }}
                          onChange={(date, dateStr) => {setClientPassportExpire(dateStr);}}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col lg={4}>
                    <FormGroup className="mb-4">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="formrow-firstname-input">Numéro de téléphone</label>
                        <PhoneInput
                          defaultCountry="ci"
                          value={clientPhone}
                          onChange={setClientPhone}
                          inputStyle={{ width: "100%" }} 
                          />
                      </div>
                    </FormGroup>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label>Email</Label>
                      <input className="form-control" placeholder="Email du client" onChange={(event)=>{ setClientEmail(event.target.value); }} type="text" id="example-datetime-local-input"/>
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                      <Label>Nationalité</Label>
                      <Select
                        value={clientNationality} 
                        isMulti={false}
                        onChange={(selected) => { setClientNationality(selected); }}
                        options={clientCountries} 
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                      <Label>Pays de résidence</Label>
                      <Select
                        value={clientResidence} 
                        isMulti={false}
                        onChange={(selected) => { setClientResidence(selected); }}
                        options={clientCountries} 
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ marginTop: 20}}>
                    <strong className="text-danger">{errorClient}</strong>
                    <strong className="text-success">{successClient}</strong>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ marginTop: 20}}>
                    <Button color="primary" style={{ fontSize: 20  }} className="form-control btn btn-primary waves-effect waves-light" onClick={()=>processSaveBeneficiary()}>Ajouter le client</Button>
                  </Col>
                </Row>
              </form>
            </ModalBody>
          </Modal>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Row>
                    <Col xl={5}>
                      <h4>Formulaire de modification d'une attestation</h4> 
                    </Col>
                    <Col xl={3}>
                        <Link color="primary" onClick={tog_beneficiary} className="form-control btn btn-primary waves-effect"><i className="fas fa-user"></i> Créer un Client</Link>
                    </Col>
                  </Row>
                  
                  <br/>
                  <form>
                    <Row>
                      <Col lg="4">
                        <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                          <Label>Bénéficiaire</Label>
                          <Select
                            value={selectedBeneficiary} isMulti={false}
                            onInputChange={(value)=>loadBeneficiaries(value)} onChange={(selected) => { handleBeneficiary(selected); }}
                            options={beneficiaries} classNamePrefix="select2-selection" isLoading={false}
                          />
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className="mb-3">
                          <Label>Date de naissance</Label>
                          <input className="form-control" placeholder="Date de naissance" disabled type="text" value={birthDate} id="example-datetime-local-input"/>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className="mb-3">
                          <Label>Age (ans)</Label>
                          <input className="form-control" placeholder="Age du client client" disabled type="text" value={age} id="example-datetime-local-input"/>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="3">
                        <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                          <Label>Zone</Label>
                          <Select value={selectedZone} onChange={handleZone} options={zones} classNamePrefix="select2-selection" />
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div className="mb-3">
                          <Label>Pays de destination</Label>
                          <Select
                            value={selectedCountry}
                            onChange={(selected) => { handleSelectCountry(selected); }}
                            options={countries} classNamePrefix="select2-selection" />
                        </div>
                      </Col>
                      <Col lg={3}>
                        <FormGroup className="form-group mb-3">
                          <Label>à partir de</Label>
                          <InputGroup className="">
                            <Flatpickr
                              className="form-control d-block"
                              placeholder="Date de début"
                              value={from}
                              options={{ altInput: true, altFormat: "Y-m-d", dateFormat: "Y-m-d" }}
                              onChange={(date, dateStr) => {setFrom(dateStr); handleDelayStart(dateStr)}}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col lg={3}>
                        <FormGroup className="form-group mb-3">
                          <Label>Jusqu'à</Label>
                          <InputGroup className="">
                            <Flatpickr
                              className="form-control d-block"
                              placeholder="Date de fin"
                              value={to}
                              options={{ altInput: true, altFormat: "Y-m-d", dateFormat: "Y-m-d" }}
                              onChange={(date, dateStr) => { setTo(dateStr); handleDelayEnd(dateStr) }}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg="5" style={{ fontSize: 20, borderRadius: 15, padding: 10, margin: 10, color: "white" }} className="bg-info">
              <Label>Durée de prise en charge</Label>
              <p>
                <strong>{delay} jour(s)</strong>
              </p>
            </Col>
            <Col lg="5" style={{ fontSize: 20, borderRadius: 15, padding: 10, margin: 10, color: "white" }} className="bg-success">
              <Label>Montant à payer</Label>
              <p>
                <strong>{amount} FCFA</strong>
              </p>
            </Col>
          </Row>
          <Row>
            <Col lg="12" style={{ marginTop: 20}}>
              <strong className="text-danger">{error}</strong>
              <strong className="text-success">{success}</strong>
            </Col>
          </Row>
          <Row>
            <Col lg="12" style={{ marginTop: 20}}>
              <Button color="primary" style={{ fontSize: 20  }} className="form-control btn btn-primary waves-effect waves-light" onClick={()=>updateAttestation()}>Modifier l'attestation</Button>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UpdateAttestation;
